<script lang="ts">
	import { onMount, type Snippet } from 'svelte';
	import { backgroundUrl } from '#lib/infrastructure/cloudinary/index.ts';
	import FloatingParticles from './FloatingParticles.svelte';

	let mounted = $state(false);
	onMount(() => {
		mounted = true;
	});

	let { children }: { children: Snippet } = $props();
</script>

<div class="page-wrapper">
	<div class="fixed">
		<img
			src={backgroundUrl(1600)}
			srcset={`${backgroundUrl(1600)} 1600w, ${backgroundUrl(1920)} 1920w, ${backgroundUrl(2560)} 2560w`}
			sizes="100vw"
			fetchpriority="low"
			class="background-image"
			alt=""
		/>
		{#if mounted}
			<FloatingParticles />
		{/if}
	</div>
	{@render children()}
</div>

<style>
	.page-wrapper {
		max-width: 1400px;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		text-align: center;
	}

	.background-image {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
		opacity: 0.25;
		filter: blur(1px);
	}

	.fixed {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
	}
</style>
